<template>
  <div class="documentContainer">
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ categoryTitle }}</span>
      </v-card-title>
      <v-card-subtitle>{{ categoryDescription }}</v-card-subtitle>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-list-item
                v-for="(item, index) in files"
                :key="index"
              >
                <v-list-item-content>
                  <v-list-item-title><v-icon left>mdi-file-document</v-icon>{{ item.name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    icon
                    @click="deleteFile(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-col>
            <v-col cols="12" sm="3">
              <v-btn
                :dark="true"
                :loading="btnLoading"
                @click="uploadFile"
              >
                <template v-slot:loader>
                  <v-progress-linear
                    :value="uploadProgress"
                    height="100%"
                    :rotate="-90"
                    color="secondary"
                  ></v-progress-linear>
                </template>
                Upload
                <v-icon right>mdi-file-plus</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm="9">
              <v-alert
                v-model="fileSizeDialog"
                border="left"
                dense
                dismissible
                text
                transition="scale-transition"
                type="error"
              >
                File size is too large!<br>
                Files must be 60mb or less
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="btnLoading"
          @click="$emit('setDialog', false)"
        >Close</v-btn>
      </v-card-actions>
    </v-card>
    <input
      ref="uploader"
      class="d-none"
      type="file"
      accept=".txt, .doc, .docx, .xls, .xlsx, .pdf"
      aria-label="Upload"
      @click="$event.target.value = null"
      @change="onFileChanged"
    >
  </div>
</template>

<script>
export default {
  name: 'DocumentsDesktop',
  props: ['categoryTitle', 'categoryDescription', 'category', 'type', 'files'],
  data: () => ({
    btnLoading: false,
    uploadProgress: 0,
    selectedFile: null,
  }),
  computed: {
    fileSizeDialog: {
      get() {
        return this.$store.state.fileSizeDialog;
      },
      set(value) {
        this.$store.commit('updateFileSizeDialog', value);
      },
    },
  },
  methods: {
    updateProgress(value) {
      this.uploadProgress = value;
    },
    uploadFile() {
      this.fileImport(this.category);
    },
    fileImport() {
      this.$refs.uploader.click();
    },
    onFileChanged(e) {
      this.btnLoading = true;
      // eslint-disable-next-line prefer-destructuring
      this.selectedFile = e.target.files[0];

      if (this.selectedFile === undefined) {
        this.btnLoading = false;
        this.uploadProgress = 0;
        return;
      }

      const file = {
        document: this.selectedFile,
        category: this.category,
        type: this.type,
        action: 'insert',
      };

      try {
        this.$store.dispatch('uploadDocument', {
          file,
          progress: (event) => this.updateProgress(event),
        }).then(() => {
          this.btnLoading = false;
          this.uploadProgress = 0;
        });
      } catch {
        this.btnLoading = false;
        this.uploadProgress = 0;
      }
    },
    deleteFile(value) {
      this.$store.dispatch('DeleteFile', value);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
